import { render, staticRenderFns } from "./FlatGuestBox.vue?vue&type=template&id=d65aa9a6&scoped=true&"
import script from "./FlatGuestBox.vue?vue&type=script&lang=js&"
export * from "./FlatGuestBox.vue?vue&type=script&lang=js&"
import style0 from "./FlatGuestBox.vue?vue&type=style&index=0&id=d65aa9a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65aa9a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d65aa9a6')) {
      api.createRecord('d65aa9a6', component.options)
    } else {
      api.reload('d65aa9a6', component.options)
    }
    module.hot.accept("./FlatGuestBox.vue?vue&type=template&id=d65aa9a6&scoped=true&", function () {
      api.rerender('d65aa9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nn8xf0CYXyVG/JS/comp/FlatGuestBox.vue"
export default component.exports